<template>
  <div :class="['price-cards', {'flex-wrap': adjustToSm}]">
    <div :class="[{'yellow-card': isYellow}, {'adjust-sm': adjustToSm}, {'no-adjust': !adjustToSm}, 'price-card']">
      <h1>Free</h1>
      <h4>Listen at {{ 0.00 | amountFilter(localPricing.currency) }}</h4>
      <div
        v-for="(item, index) in priceCardsOffers"
        :key="index"
        class="price-content">
        <i
          :class="index < 2 ? 'el-icon-check' : 'el-icon-close'" />
        <p :class="{'text-light-gray': index > 1}">{{ item }}</p>
      </div>
      <el-button
        class="el-button el-button--primary"
        data-test="btn-signupfree"
        @click="getStartedFree(freePage)"
      >Get Started</el-button>
    </div>
    <div :class="[{'yellow-card': isYellow}, {'adjust-sm': adjustToSm}, {'no-adjust': !adjustToSm}, 'price-card']">
      <h1>Premium</h1>
      <h4>Listen at {{ localPricing.price | amountFilter(localPricing.currency) }}</h4>
      <div
        v-for="(item, index) in priceCardsOffers"
        :key="index"
        class="price-content">
        <i
          class="el-icon-check" />
        <p>{{ item }}</p>
      </div>
      <el-button
        class="el-button el-button--primary"
        data-test="btn-subscribepremium"
        @click="tryPremium('/premium-buy')"
      >Try
        <span
          v-if="promoMeta.trialPeriod > 1"
          class="line-through">1 month</span> {{ promoMeta.formattedTrialPeriod }} free</el-button>
    </div>
    <custom-info
      :show="showInfoModal"
      :header="infoHeader"
      :description="infoDescription"
      @closeInfoModal="closeInfoModal"
    />
  </div>
</template>
<script>
import CustomInfoModal from './InfoCustomModal';

export default {
  name: 'PriceCards',
  components: {
    'custom-info': CustomInfoModal,
  },
  props: {
    isYellow: {
      type: Boolean,
      default: false,
    },
    adjustToSm: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      priceCardsOffers: [
        'Hundreds of thousands of shows you already listen to and love',
        'Personalized recommendations that learn your listening style',
        'Access 40+ Luminary Originals coming this year',
        'Uninterrupted and ad-free listening of all Luminary Originals',
      ],
      freePage: this.$store.getters.loggedIn ? '/account/subscription' : '/signup',
      premiumPage: this.$store.getters.loggedIn ? '/premium-buy' : '/signup',
      defaultPrice: this.$store.getters.pricing,
      showInfoModal: false,
      infoHeader: '',
      infoDescription: '',
    };
  },
  methods: {
    getStartedFree(path) {
      const { user } = this.$store.getters;
      if (user && user.is_subscribed) {
        this.showSuccessMsg('You already have a premium subscription.');
      } else if (user && !user.is_subscribed) {
        this.showSuccessMsg('This is your current plan.');
        this.$router.push(path);
      } else {
        this.$router.push(path);
      }
    },
    tryPremium(path) {
      const { user } = this.$store.getters;
      if (user && user.is_subscribed) {
        this.showSuccessMsg('This is your current plan.');
      } else if (user && !user.is_subscribed && user.is_on_boarded) {
        this.showErrorMsg('You are not eligible for another free trial.');
      } else {
        this.$router.push(path);
      }
    },
    displayInfoModal() {
      this.infoHeader = 'Info';
      this.infoDescription = 'You are already a Premium subscriber';
      this.showInfoModal = true;
    },
    closeInfoModal() {
      this.showInfoModal = false;
    },
  },
};
</script>
<style lang="scss">
@import "../assets/scss/variables.scss";

.price-cards {
  display: flex;
  justify-content: center;
  .price-card {
    flex: 1 0 100%;
    background: #fff;
    box-shadow: 12px 13px 0px 2px rgba(200,200,200,.3);
    padding: 30px 15px 40px 40px;
    max-width: 360px;
    transition: .3s all ease-in-out;
    &.yellow-card {
      background-color: $brand !important;
      box-shadow: 12px 13px 0px 2px rgba(255,197,0,0.25);
      a {
        background-color: #FFFFFF;
        border: none;
        color: $black;
        font-family: Favorit;
        &:hover {
          background-color: #F5F4F4;
        }
      }
      .price-content {
        .text-light-gray {
          color: $gray !important;
        }
      }
    }
    &:first-child {
      margin-right: 45px;
    }
    a {
      padding: 15px 35px;
      margin-top: 15px;
      text-transform: none;
    }
    h1 {
      font-family: $clearface-bold;
      letter-spacing: -1px;
      font-size: 50px;
      padding: 12px 0 24px;
      margin: 0 0;
    }
    h4 {
      font-size: 24px;
      line-height: 32px;
      margin: 0 0 20px 0;
    }
    .price-content {
      display: flex;
      flex: 1;
      p {
        font-family: Favorit-light;
        font-size: 16px;
        line-height: 24px;
        color: $black;
      }
      i {
        margin: 6px 10px 0 0;
        font-size: 32px;
        font-weight: bold;
        &.el-icon-close {
          color: #FF5D5D;
        }
        &.el-icon-check {
          color: #54A640;
        }
      }
    }
  }
}

@media (max-width: 1024px) {
  .price-cards {
    .price-card {
      &.adjust-sm {
        flex-wrap: wrap;
        padding: 26px;
        max-width: 325px;
        /* min-width: 90%; */
        min-width: 35%;
        margin: 15px 30px 15px 15px !important;
        h1 {
          font-size: 36px;
          padding-bottom: 12px;
        }
        h4 {
          font-size: 18px;
          margin-bottom: 10px;
          font-family: Favorit;
        }
        .price-content {
          padding-bottom: 8px;
          p {
            font-size: 16px;
            line-height: 21px;
            color: $black;
            margin: 0 0;
          }
          a {
            margin-top: 12px;
          }
          i {
            margin: 3px 5px 0 0;
            font-size: 18px;
          }
        }
      }
    }
  }
}

@media (max-width: 768px) {
  .price-cards {
    .price-card {
      &.no-adjust {
          padding: 15px;
          &:first-child {
            margin-right: 15px;
          }
      }
    }
  }
}

@media (max-width: 702px) {
  .price-card {
    &.adjust-sm {
      &:first-child {
        order: 2;
      }
      &:nth-child(2) {
        order: 1;
      }
    }
  }
}
@media (max-width: 576px) {
  .price-cards {
    flex-wrap: wrap;
    .price-card {
      &:first-child {
        margin-right: 0px;
        margin-bottom: 45px;
        order: 2;
      }
      &:nth-child(2) {
        order: 1;
      }
      &.no-adjust {
        max-width: 325px;
        min-width: 90%;
        margin: 15px 30px 15px 15px !important;
        h1 {
          font-size: 36px;
        }
        h4 {
          font-size: 18px;
          line-height: 28px;
          margin: 10px 0;
          font-family: Favorit;
        }
        .price-content {
          margin-bottom: 12px;
          p {
            font-size: 16px;
            color: $black;
            margin: 0 0;
          }
          i {
            font-size: 22px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// app/src/components/PriceCards.vue